import { AUTH_URL } from '../config';
import { createAuthClient } from 'better-auth/react';
import {
  emailOTPClient,
  inferAdditionalFields,
} from 'better-auth/client/plugins';
import { impersonationClient } from '@agave/auth-impersonation/client';

export const authClient = createAuthClient({
  baseURL: AUTH_URL,
  plugins: [
    emailOTPClient(),
    impersonationClient(),
    inferAdditionalFields({
      user: {
        // Add any additional user fields that your backend defines
        // For example, if your backend has role, permissions, etc.
      },
    }),
  ],
  fetchOptions: {
    credentials: 'include', // Include cookies in all requests
  },
});
